import axios from '@/core/axios';

import { CollectionList } from '../collections/collections.types';
import {
  TaxAccountingEntry,
  TaxAccountingEntryPayload,
  TaxAccountingEntriesListOptions
} from './tax-accounting-entries.types';

export class TaxAccountingEntriesService {
  async list(opts: TaxAccountingEntriesListOptions = {}): Promise<CollectionList<'tax-accounting-entries'>> {
    const { filters, pagination } = opts;
    const resp = await axios.get<CollectionList<'tax-accounting-entries'>>('/accounting/tax-accounting-entries', {
      params: { ...filters, ...pagination }
    });
    return resp?.data;
  }

  async get(id: number): Promise<TaxAccountingEntry> {
    const resp = await axios.get<TaxAccountingEntry>(`/accounting/tax-accounting-entries/${id}`);
    return resp?.data;
  }

  async newEntry(): Promise<TaxAccountingEntry> {
    const resp = await axios.get<TaxAccountingEntry>('/accounting/tax-accounting-entries/new');
    return resp?.data;
  }

  async create(payload: TaxAccountingEntryPayload): Promise<TaxAccountingEntry> {
    const resp = await axios.post<TaxAccountingEntry>('/accounting/tax-accounting-entries', {
      tax_accounting_entry: payload
    });
    return resp?.data;
  }

  async update(id: number, payload: Partial<TaxAccountingEntryPayload>): Promise<TaxAccountingEntry> {
    const resp = await axios.put<TaxAccountingEntry>(`/accounting/tax-accounting-entries/${id}`, {
      tax_accounting_entry: payload
    });
    return resp?.data;
  }

  async destroy(id: number): Promise<void> {
    await axios.delete(`/accounting/tax-accounting-entries/${id}`);
  }
}

export const taxAccountingEntriesService = new TaxAccountingEntriesService();
